import React from "react";
import moment from "moment";
import { useParams } from "react-router-dom";
import useAllPlayers from "../../hooks/queryResults/useAllPlayers";
import useGetter from "../../hooks/queryResults/useGetter";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useTeams from "../../hooks/queryResults/useTeams";
import Box from "../layout/Box";
import PlayerImageByPos from "../player/PlayerImageByPos";
import { getPlayerName } from "../player/PlayerName";
import Loading from "../ui/Loading";

export default function LeagueAllWaiversRequests() {
  const { league: leagueUrl, season: seasonUrl } = useParams();
  const { playersData, playersQuery } = useAllPlayers();
  const { teams, teamsQuery } = useTeams();
  const { data: allWaiversRequestsData, query: allWaiversRequestsQuery } =
    useGetter(`/rosters/${leagueUrl}/${seasonUrl}/requests`);

  const isLoading = useIsLoading(
    allWaiversRequestsData,
    allWaiversRequestsQuery,
    playersData,
    playersQuery,
    teams,
    teamsQuery
  );
  if (isLoading) return <Loading />;

  return (
    <Box title={"waivers requests"} centerContent={true}>
      {allWaiversRequestsData.map(({ team: teamId, requests }) => {
        if (requests.length === 0) return null;
        const team = teams.getTeamById(teamId);

        return (
          <div key={teamId}>
            <h1>{team.fullName}</h1>
            <table>
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Num</th>
                  <th>Add</th>
                  <th>Drop</th>
                  <th>Processed</th>
                  <th>Accepted</th>
                </tr>
              </thead>
              <tbody>
                {requests.map((request) => {
                  const { num } = request;

                  const printPlayer = (playerId) => {
                    const player = playersData.players[playerId];
                    return (
                      <div
                        key={playerId}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <PlayerImageByPos
                          player={player}
                          style={{
                            maxWidth: "18px",
                          }}
                        />
                        <div style={{ marginLeft: "0.25rem" }}>
                          {getPlayerName(player, {
                            pos: 1,
                            nfl: 1,
                            injury: 1,
                          })}
                        </div>
                      </div>
                    );
                  };

                  let playerIn = null;
                  if (request.playerIn) {
                    playerIn = printPlayer(request.playerIn);
                  }

                  let playerOut = null;
                  if (request.playerOut) {
                    playerOut = printPlayer(request.playerOut);
                  }

                  return (
                    <tr key={request.id}>
                      <td>{request.id}</td>
                      <td>{num}</td>
                      <td>{playerIn}</td>
                      <td>{playerOut}</td>
                      <td>
                        {request.processDate
                          ? moment(request.processDate).format(
                              "ddd MMM D [at] h:mm a"
                            )
                          : null}
                      </td>
                      <td>
                        {request.hasOwnProperty("wasAccepted")
                          ? request.wasAccepted
                            ? "YES"
                            : "no"
                          : null}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      })}
    </Box>
  );
}
